import { render, staticRenderFns } from "./WorkersListCard.vue?vue&type=template&id=5f4b79be"
import script from "./WorkersListCard.vue?vue&type=script&lang=js"
export * from "./WorkersListCard.vue?vue&type=script&lang=js"
import style0 from "./WorkersListCard.vue?vue&type=style&index=0&id=5f4b79be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports